const initialState = {
  deviceScanStatusArr: []
}

export default function filtersReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_DEVICE_SCAN_STATUS': {

      let ns = {
        ...state
      };

      ns.deviceScanStatusArr = action.data.deviceScanStatusArr

      return ns;
    }
    default:
      return state
  }
}


export function updateDeviceScanStatus(newDeviceStatus) {
  if (window.store) {
    const store = window.store

    const currentStatus = store.getState().inventory.deviceScanStatusArr
    
    let modified = false;

    let newArr = currentStatus.map(obj => {
        if(obj.deviceId == newDeviceStatus.deviceId) {
          modified = true;
          return { ...newDeviceStatus};
        } else return obj;
      }
    );

    if(!modified) {
      newArr = [...newArr, newDeviceStatus]
    }

    store.dispatch({
      "type": "UPDATE_DEVICE_SCAN_STATUS",
      "data": {
        deviceScanStatusArr: newArr
      }
    })
  }
}